import { type DocumentReference } from 'firebase/firestore';

import { DocumentCollectionType } from 'types/DocumentCollectionType';
import { DocumentType } from 'types/DocumentType';

import Creative from './Creative';
import DocumentFolder, { type DocumentFolderParent } from './DocumentFolder';
import DocumentFolderCollection from './DocumentFolderCollection';
import { FolderPublicSchema, FolderSchema } from './DocumentFolderTypes';

export default class Project extends DocumentFolder {
    schema = new FolderSchema();
    publicSchema = new FolderPublicSchema();
    type = DocumentType.PROJECT;
    collectionType = DocumentCollectionType.PROJECT;
    documents = new DocumentFolderCollection(this, Creative);

    constructor(parent: DocumentFolderParent, docRef?: DocumentReference) {
        super(parent, docRef);
        this.becomeObservable();
    }
}
